module.exports = __webpack_public_path__ + "img/arrow.e91751bf.svg";